import React, { useState, Fragment } from 'react';
import { connect } from "react-redux";

import { useDrizzleContext } from "../drizzle/drizzleContext";

import CreatePage from './CreatePage';

const CreatePageContainer = ({ accounts, transactions, transactionStack }) => {
  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.THDJabraToken;

  const [ data, setData ] = useState( {jabraNumber: "", reserveDate: "" });
  const [ stackId, setStackId ] = useState(null);
  const [ isMintingToken, setIsMintingToken ] = useState(false);

  const handleChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  }

  const handleSubmit = e => {
    e.preventDefault();
    // FIXME I have to implement "isDate".
    data.jabraNumber = parseInt(data.jabraNumber);
    const jabraNumberInSolidity = data.jabraNumber - 1;

    if (Number.isInteger(data.jabraNumber))
      setValue(jabraNumberInSolidity, data.startDate, data.endDate);

   e.target.reset();
  }

  const setValue = async (jabraNumberInSolidity, startDate, endDate) => {
    const startConverted = Date.parse(startDate) / 1000;
    const endConverted = Date.parse(endDate) / 1000;

    const estimatedGas = await contract.methods.mintTokensForPeriod(
        jabraNumberInSolidity, startConverted, endConverted
      ).estimateGas({
        from: accounts[0]
    });

    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const multiplicationFactor = 1.3;
    const gasPriceMultiplication = 2.4;

    /**
     * @dev we can give not jabraId and reserveDate but tokenId, so we have to check the normality of jabraNumber < 256 here, not in the source of Solidity.
     **/
    const _stackId = await contract.methods["mintTokensForPeriod"].cacheSend(jabraNumberInSolidity, startConverted, endConverted, {
      from: accounts[0],
      gas: Math.floor(estimatedGas*multiplicationFactor),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication),
    });
    setStackId(_stackId);
    turnMintStatus(true);
  }

  const getTxStatus = () => {
    // get the transaction hash using our saved `stackId`
    const txHash = transactionStack[stackId];

    // if transaction hash does not exist, don't display anything
    if (!txHash) return null; // FIXME

    if(transactions[txHash]) {
      if (transactions[txHash].status === 'success' && isMintingToken)
        turnMintStatus(false);

      // otherwise, return the transaction status
      return (
        <Fragment>
          <span>Transaction Status: </span><span className='charcoal'>{transactions[txHash].status}</span>
        </Fragment>
      );
    }
    return (transactions[txHash] &&
      <Fragment>
        <span>Transaction Status: </span><span className='charcoal'>{transactions[txHash].status}</span>
      </Fragment>
    );
  }

  const turnMintStatus = newstate => {
    setIsMintingToken(newstate);
  }

  return (
    <CreatePage
      transactions={transactions}
      transactionStack={transactionStack}
      getTxStatus={getTxStatus}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
}

const mapStateToProps = state => {
  return {
    accounts: state.accounts,
    transactions: state.transactions,
    transactionStack: state.transactionStack
  };
};

export default connect(mapStateToProps)(CreatePageContainer);
